import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
    return {
        dashboardPaper: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(3),
            borderRadius: '8px',
            [theme.breakpoints.down('lg')]: {
                maxWidth: '75vw',
            },
            [theme.breakpoints.down('md')]: {
                maxWidth: '60vw',
            },
            [theme.breakpoints.down('sm')]: {
                maxWidth: 'unset',
            },
        },
    };
});

export default useStyles;
